module.exports = "<p>equipment works!</p>\n"